import { Grid, TextField, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import styles from "../../../assets/styles/componentStyles/apiKeyStyles/apiKeyStyle.module.scss"
import globalStyles from "../../../assets/styles/global.module.scss";
import Required from '../../../components/utility/required';
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import { createApiKeyPayload } from '../../../models/axiosModel';
import GlobalButton from '../../../components/utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import { useApiKeyStore } from '../../../store/apiKeyStore';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface CreateApiKeyPopupProps {
    getApiKey: () => Promise<void>,
}

const CreateApiKeyPopup: React.FC<CreateApiKeyPopupProps> = (props) => {

    const { getApiKey } = props;

    const [payload, setPayload] = useState<createApiKeyPayload>({ api_key_name: "" });
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const setFlagCreateApiKeyPopup = useApiKeyStore((store) => store.setFlagCreateApiKeyPopup);
    const setFlagSaveApiKeyPopup = useApiKeyStore((store) => store.setFlagSaveApiKeyPopup);
    const setSecretApiKey = useApiKeyStore((store) => store.setSecretApiKey);

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const onChangeOfApiKeyName = (value: string) => {
        setPayload((prev) => ({
            ...prev,
            api_key_name: value,
        }))
    }

    const checkDisableCreateBtn = () => {
        return payload?.api_key_name?.trim()?.length === 0;
    }

    const onClickofCreateApiKey = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await agent.createApiKey.post(payload);
        if (res.status) {
            getApiKey();
            showSuccess("API Key created successfully")
            setSecretApiKey(res?.data?.api_key);
            setFlagSaveApiKeyPopup(true);
        } else {
            handleError(res);
        }
        setFlagCreateApiKeyPopup(false);
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    return (
        <>
            <Grid container className={`${styles.createKeyPopup} ${globalStyles.flexColumn}`} gap={2}>
                <Grid item xs={12}>
                    <Grid container gap={1}>
                        <Grid item xs={12}>
                            <Typography className={`${styles.createKeyPopupTitle} `}>Create New API Key</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={`${styles.createKeyDesc} `}>
                                Give your key a recognizable name so you can identify it later (e.g. "Payment Service")
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <Grid container className={`${globalStyles.flexColumn}`} gap={1}>
                            <Grid item>
                                <Typography className={contactStyles.popupFieldTypography}>API Key Name <Required /></Typography>
                            </Grid>
                            <Grid>
                                <TextField
                                    value={payload.api_key_name}
                                    onChange={(e) => onChangeOfApiKeyName(e.target.value)}
                                    placeholder='Enter API Key Name'
                                    className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid container mt={1} className={`${globalStyles.alignItemCenter}`}>
                        <Grid item>
                            <GlobalButton
                                className='primaryButtonStyle'
                                buttonText="Create"
                                sx={{ width: "140px" }}
                                disabled={checkDisableCreateBtn()}
                                onClick={onClickofCreateApiKey}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CreateApiKeyPopup
